import NotInterestedIcon from "@mui/icons-material/NotInterested";
import { Box, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import React from "react";
import { EntityUserDTO } from "../../../api/dto";
import typography from "../../../typography";
import UserAvatar from "../../UserAvatar";
import BaseChatEntry from "./BaseChatEntry";

type Props = {
  date: Date;
  author: EntityUserDTO;
}

function DeletedChatEntry({author, date}: Props) {
  const avatar = (
    <UserAvatar
      firstName={author.first_name}
      lastName={author.last_name}
      entityUserXrefUuid={author.entity_user_xref_uuid}
    />
  );
  return (
    <BaseChatEntry
      avatar={avatar}
      date={date}
      position={author.me ? 'right' : 'left'}
      name={author.me ? 'You' : `${author.first_name} ${author.last_name}`}
    >
      <Box paddingY={1} color={grey[400]}>
        <Stack alignItems="center" direction="row" gap={0.5}>
          <NotInterestedIcon fontSize={'small'}/>
          <Typography
            component="span"
            fontSize={typography.m}
            margin={0}
          >
            This message was deleted
          </Typography>
        </Stack>

      </Box>
    </BaseChatEntry>
  );
}

export default DeletedChatEntry;
